module.exports = __webpack_public_path__ + "assets/img/crayon11.92121b5b.png";